module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUAQMAAADWX60MAAAABlBMVEXcFDz////vuDXSAAAAEElEQVQI12P4DwQMJBEkAwCtUSfZb7JSvgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/pl.png
// module id = 365
// module chunks = 0